// 2. Updated gamificationActionThunks.js - Add all missing thunks
import { createAsyncThunk } from '@reduxjs/toolkit';
import GamificationAPI from './gamificationAPI';

export const fetchPointsThunk = createAsyncThunk(
  'gamification/fetchPoints',
  async (userId, { rejectWithValue }) => {
    try {
      const points = await GamificationAPI.fetchPoints(userId);
      return { userId, points };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch points');
    }
  }
);

export const addPointsThunk = createAsyncThunk(
  'gamification/addPoints',
  async ({ userId, pointsData }, { rejectWithValue }) => {
    try {
      const points = await GamificationAPI.addPoints(userId, pointsData);
      return { userId, points };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to add points');
    }
  }
);

export const createBadgeThunk = createAsyncThunk(
  'gamification/createBadge',
  async (badgeData, { rejectWithValue }) => {
    try {
      return await GamificationAPI.createBadge(badgeData);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to create badge');
    }
  }
);

export const assignBadgeThunk = createAsyncThunk(
  'gamification/assignBadge',
  async (assignmentData, { rejectWithValue }) => {
    try {
      const badge = await GamificationAPI.assignBadge(assignmentData);
      return { userId: assignmentData.userId, badge };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to assign badge');
    }
  }
);

export const fetchUserBadgesThunk = createAsyncThunk(
  'gamification/fetchUserBadges',
  async (userId, { rejectWithValue }) => {
    try {
      const badges = await GamificationAPI.fetchUserBadges(userId);
      return { userId, badges };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch user badges');
    }
  }
);

export const fetchBadgeProgressThunk = createAsyncThunk(
  'gamification/fetchBadgeProgress',
  async (userId, { rejectWithValue }) => {
    try {
      const progress = await GamificationAPI.fetchBadgeProgress(userId);
      return { userId, progress };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch badge progress');
    }
  }
);

export const fetchLeaderboardThunk = createAsyncThunk(
  'gamification/fetchLeaderboard',
  async (limit = 10, { rejectWithValue }) => {
    try {
      return await GamificationAPI.fetchLeaderboard(limit);
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch leaderboard');
    }
  }
);

export const deleteBadgeThunk = createAsyncThunk(
  'gamification/deleteBadge',
  async (badgeId, { rejectWithValue }) => {
    try {
      const result = await GamificationAPI.deleteBadge(badgeId);
      return { badgeId, ...result };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete badge');
    }
  }
);